import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-clause',
  templateUrl: './clause.component.html',
  styleUrls: ['./clause.component.css']
})
export class ClauseComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
